var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148616",
    "data-name": "Rectangle 148616",
    width: 24,
    height: 24,
    fill: "#1a1a1a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hide",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hide-2",
    "data-name": "hide",
    transform: "translate(1.851 -45.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11753",
    "data-name": "Group 11753",
    transform: "translate(0 49.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11752",
    "data-name": "Group 11752",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8913",
    "data-name": "Path 8913",
    d: "M18.047,49.242a.746.746,0,0,0-1.056,0l-2.651,2.651A10.157,10.157,0,0,0,4.207,52.95,16.932,16.932,0,0,0,.143,56.7a.752.752,0,0,0,.021.911A18.315,18.315,0,0,0,4.58,61.653L2.248,63.985A.745.745,0,1,0,3.3,65.041L18.047,50.3A.75.75,0,0,0,18.047,49.242ZM8.3,57.929a1.939,1.939,0,0,1-.162-.787,2.008,2.008,0,0,1,2.8-1.847ZM12.04,54.2a3.5,3.5,0,0,0-4.83,4.83L5.674,60.564a15.688,15.688,0,0,1-3.96-3.434A15.955,15.955,0,0,1,5.023,54.2,8.692,8.692,0,0,1,13.2,53.033Z",
    transform: "translate(0 -49.023)",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11755",
    "data-name": "Group 11755",
    transform: "translate(7.484 53.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11754",
    "data-name": "Group 11754",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8914",
    "data-name": "Path 8914",
    d: "M193.314,156.83a19.969,19.969,0,0,0-3.161-3.161.748.748,0,1,0-.924,1.176,17.813,17.813,0,0,1,2.535,2.465,16.344,16.344,0,0,1-2.734,2.539,9.214,9.214,0,0,1-7.469,1.943.745.745,0,0,0-.307,1.458,9.282,9.282,0,0,0,1.939.2,9.855,9.855,0,0,0,2.945-.46,13.151,13.151,0,0,0,3.807-1.968,17.111,17.111,0,0,0,3.388-3.285A.752.752,0,0,0,193.314,156.83Z",
    transform: "translate(-180.663 -153.512)",
    fill: "#1a1a1a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.43ceec74.svg";
export { ForwardRef as ReactComponent };